
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const hasList = (list) => list && list.length > 0
  const { statuses, fleetNames } = filters

  const onSelect = createOnFilter(onFilter)

  const fleetOptions = fleetNames && fleetNames.map(({ value, text }) => {
    return {
      label: text,
      value
    }
  })

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {fleetNames && hasList(fleetNames) && (
          <MuiFormSelect
            id="fleet"
            label="Fleet"
            options={fleetOptions}
            value={filtered.thirdPartyNumber}
            onChange={onSelect('thirdPartyNumber')}
            includeEmptyOption/>
        )}
        {statuses && hasList(statuses) && (
          <MuiFormSelect
            id="status"
            label="Status"
            options={statuses}
            value={filtered.status}
            onChange={onSelect('status')}
            includeEmptyOption/>
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
